import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import '../../css/Dashboard.css';
import { useDashboardData } from './DashboardDataContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,    // for line
  LineElement,     // for line
  Tooltip,
  Legend
);


const QueriesOverTimeComponent = () => {
  const [data, setData] = useState<any>({ labels: [], datasets: [] });
  const { data: dash } = useDashboardData();
  useEffect(() => {
    if (!dash) return;
    const labelsArr = (dash.queriesOverTime || []).map(x => x.date);
    const counts = (dash.queriesOverTime || []).map(x => x.count);

    const labels = labelsArr.map(k => {
      const [yy, mm, dd] = k.split('-').map(Number);
      const d = new Date(yy, (mm || 1) - 1, dd || 1);
      return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short' });
    });
    setData({
      labels,
      datasets: [
        {
          label: 'Queries',
          data: counts,
          fill: false,
          backgroundColor: '#6366f1',
          borderColor: '#6366f1',
        },
      ],
    });
  }, [dash]);

  return (
    <div className="card">
      <h4 className="card-title">Queries Over Time</h4>
      <Line data={data} />
    </div>
  );
};

export default QueriesOverTimeComponent;
